export default "__VITE_ASSET__88XOoO8h__"